<template>
    <div>
        <TimerBody
            v-if="timer.uuid"
            :timer="timer"
            @updateIframeHeight="updateHeight"
            @updateIframeView="updateView"
        />
    </div>
</template>

<script>
import TimerBody from "@/views/tools/timer/TimerBody.vue";
import { setFontFamily, updateIframeHeight, updateIframeView } from "@/shared/utils";
import { prepareTimer } from "@/shared/projects/prepareData";
import { PREVIEW_ROUTE_NAMES } from "@/views/preview/preview.routes";
import { projectsService } from "@/shared/projects/projects.service";

export default {
    name: "TimersPreview",
    components: {
        TimerBody,
    },
    data() {
        return {
            timer: {},
            windowWidth: window.innerWidth,
            currentFont: "Inter",
            waiting: false,
        };
    },
    async mounted() {
        if (window.location === window.parent.location) {
            try {
                this.timer = await this.loadTimer(this.$route.params.timer_uuid);
                this.adjustIframe();
            } catch {
                this.$router.push({ name: PREVIEW_ROUTE_NAMES.notFound });
            }
        } else {
            window.addEventListener("message", this.refreshIframe);
        }

        window.addEventListener("resize", this.resizeIframe);
    },
    beforeUnmount() {
        window.removeEventListener("message", this.refreshIframe);
        window.removeEventListener("resize", this.resizeIframe);
    },
    methods: {
        async loadTimer(uuid) {
            this.waiting = true;
            const timer = await projectsService.getOne({ tool: "timer", uuid });
            this.waiting = false;
            return prepareTimer(timer);
        },
        refreshIframe(e) {
            if (e.data.timerData) {
                this.timer = prepareTimer(e.data.timerData);
                this.adjustIframe();
            }
        },
        async adjustIframe() {
            this.currentFont = setFontFamily(this.timer.fontFamily, this.currentFont);
            await this.$nextTick();
            this.updateHeight();
        },
        updateHeight() {
            updateIframeHeight("timer", this.timer.uuid);
        },
        updateView(view) {
            updateIframeView("timer", this.timer.uuid, view);
        },
        resizeIframe() {
            if (window.innerWidth !== this.windowWidth) {
                this.adjustIframe();
                this.windowWidth = window.innerWidth;
            }
        },
    },
};
</script>
